export interface AccountActivationData {
  // Authentifizierungsdaten
  email: string;
  emailConfirm: string;
  password: string;
  passwordConfirm: string;
  
  // Kundendaten, die bereits vom ersten Schritt bekannt sind
  firstname: string;
  lastname: string;
  customerNumber: string;
  dateOfBirth: Date;
  customer_id: string; // Die Kunden-ID vom ersten Schritt
  
  // Zusätzliche Kundendaten
  salutation: Salutation;
  telefon: string;
  street: string;
  postalCode: string;
  city: string;
  country: string;
  
  // Einwilligungen
  termsAccepted: boolean;
  marketingAccepted?: boolean;
}

export interface AccountActivationResponse {
  success: boolean;
  message?: string;
  error?: string;
  data?: {
    userId: string;
    customerId: string;
    jwt: string;
  };
}

export enum Salutation {
  Herr = "1",
  Frau = "2"
}